export enum HttpErrorTypes {
  blocked = 'blocked',
}
